interface JsonLdScriptProps {
  json: string;
}

const JsonLdScript = ({ json }: JsonLdScriptProps) => (
  <script type="application/ld+json">{json}</script>
);

export default JsonLdScript;
